import { useState, useEffect } from 'react';

// project imports
//import NavUser from './NavUser';
import Box from '@mui/material/Box';
import Navigation from './Navigation';
import SimpleBar from 'components/third-party/SimpleBar';

import { getSubRoot, getSubRootName, logoMap } from '../../../../utils/utils';
import { useGetMenuMaster } from 'api/menu';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import { Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

// ==============================|| DRAWER CONTENT ||============================== //

export default function DrawerContent() {  
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  const [isReady, setIsReady] = useState(true);
  const [localDrawerOpen, setLocalDrawerOpen] = useState(drawerOpen);

  useEffect(() => {
    // 1. Scompare IMMEDIATAMENTE
    setIsReady(false);

    // 2. Alla fine del timer cambia il layout e fa riapparire i dati
    const timer = setTimeout(() => {
      setLocalDrawerOpen(drawerOpen);
      setIsReady(true);
    }, 500); // Durata del timer (es. 500ms, aumentalo a 1000 se vuoi 1 secondo pieno di attesa)

    return () => clearTimeout(timer);
  }, [drawerOpen]);

  return (
    <>
     
      <Box sx={{ flex: '1 1 auto', minHeight: 120, overflow: 'hidden' }}>
        <SimpleBar sx={{ '& .simplebar-content': { display: 'flex', flexDirection: 'column' } }}>
          <Navigation />
        </SimpleBar>
      </Box>

      <Box
        sx={{
          borderTop: "2px solid",
          borderTopColor: "divider",
          p: 0,
          minHeight: '100px',
          flexShrink: 0,
          opacity: isReady ? 1 : 0,
          transition: isReady ? "opacity 0.4s ease-in-out" : "none",
          // Aggiungi queste due righe per gestire l'altezza dei figli
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box 
          sx={{ 
            display: "flex", 
            borderRadius: 4, 
            flex: 1, // Occupa tutto lo spazio verticale disponibile
            // Se aperto allinea a sinistra (flex-start), se chiuso centra
            justifyContent: localDrawerOpen ? "flex-start" : "center", 
            alignItems: "center" 
          }}
        >
          <img
            src={logoMap[getSubRootName()]}
            alt=""
            style={{
              padding: '10px',
              maxHeight: "70px",
              height: "auto",
              objectFit: "contain",
              transition: "width 0.1s ease",
              ...(getSubRootName() === 'seriea' && {
                maxWidth: localDrawerOpen ? "70px" : "100%",
              }),
            }}
          />
          
          {localDrawerOpen && (
            <Box
              sx={{
                ml: 1,
                height: '100%',
                display: "grid",
                gridTemplateColumns: "auto 1fr",
                columnGap: 0.5,
                rowGap: 0,
                alignItems: "start",
                alignContent: "center",
                flex: 1,
                minWidth: 0,
                overflow: "hidden",
              }}
            >
              <Typography variant="caption" sx={{ whiteSpace: 'nowrap' }}>
                License:
              </Typography>
              <Tooltip title={`${import.meta.env.VITE_INBRIEF_LICENCE}`}>
                <Typography
                  variant="caption"
                  sx={{
                    display: '-webkit-box',
                    width: '100%',
                    minWidth: 0,
                    whiteSpace: 'normal',
                    fontSize: '0.65rem',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    overflowWrap: 'anywhere',
                  }}
                >
                  {import.meta.env.VITE_INBRIEF_LICENCE}
                </Typography>
              </Tooltip>

              <Typography variant="caption" sx={{ whiteSpace: 'nowrap' }}>
                Version:
              </Typography>
              <Typography variant="caption">
                {import.meta.env.VITE_MUI_APP_VERSION}
              </Typography>
            </Box>
          )}
        </Box>

        {localDrawerOpen && 
          <Box sx={{ display: 'flex', justifyContent: 'space-between', px: 1, pb: 1 }}>
            <MuiLink
              component={RouterLink}
              to={`${getSubRoot(window.location.pathname)}/term_of_service`}
              underline="hover"
              sx={{ color: 'disabled', fontWeight: 'bold', fontSize: '12px', cursor: 'pointer' }}
            >
              Terms of Service
            </MuiLink>

            <MuiLink
              component={RouterLink}
              to={`${getSubRoot(window.location.pathname)}/privacy_policy`}
              underline="hover"
              sx={{ color: 'disabled', fontWeight: 'bold', fontSize: '12px', cursor: 'pointer' }}
            >
              Privacy Policy
            </MuiLink>
          </Box>
        }
      </Box>
      {/* <NavUser /> */}
    </>
  );
}